module.exports = __webpack_public_path__ + "img/image3.7fe81104.png";